import React from 'react';
import PropTypes from 'prop-types';
import FeatureSet from './FeatureSet';
import Brochure from './Brochure';

const API_URL = process.env.REACT_APP_CMS;

const Pricing = ({ currentPricing }) => {
    const { items, brochure } = currentPricing;
    const shortText = currentPricing.translations.brochure_cta_text;

    const allFeatureSets = new Set();
    items.forEach((item) => {
        allFeatureSets.add(item.translations.title);
    });

    const scrollToElement = (id) => {
        const element = document.getElementById(id);
        element.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <div className="pricing-wrapper">
            <div className="pricing-container">
                {items.map((item, index) => (
                    <div key={ `pricing-plan-${ index }` } className="pricing-plan">
                        <div className={ `pricing-plan-title item-${ index % 3 }` }>
                            <span dangerouslySetInnerHTML={ { __html: item.translations.title } }/>
                            {item.translations.subtitle &&
                            <div className="pricing-plan-subtitle" dangerouslySetInnerHTML={ { __html: item.translations.subtitle } }/>}
                        </div>
                        <div className="pricing-plan-price">
                            <div className="price-amount">
                                <span className="price-currency">€</span>
                                {item.translations.price}
                            </div>
                            {item.translations.duration && <div>{item.translations.duration}</div>}
                        </div>
                        <div>
                            {Array.from(allFeatureSets.values()).map((featureSet, featureIndex) => (
                                <div className="pricing-plan-feature-set" key={ `feature-set-${ featureIndex }` }>
                                    <FeatureSet
                                      featureSet={ featureSet }
                                      featureIndex={ featureIndex }
                                      item={ featureIndex <= index ? items[featureIndex] : null }
                                    />
                                </div>
                            ))}
                        </div>
                        <div className={ `pricing-plan-button-wrapper item-${ index % 3 }` }>
                            <button type="button" onClick={ () => scrollToElement('estimation-form-inputs-bg') } className="pricing-plan-button ">
                                {item.translations.button_cta_text}
                            </button>
                        </div>
                        <div className="pricing-plan-brochure">
                            <a href={ `${ API_URL }/assets/${ item.translations.brochure }` } target="_blank" rel="noopener noreferrer">
                                {item.translations.brochure_cta_text}
                            </a>
                        </div>
                    </div>
            ))}
            </div>
            {brochure && brochure.type === 'file' && <Brochure brochure={ brochure } shortText={ shortText }/>}
        </div>
    );
};

Pricing.propTypes = {
    currentPricing: PropTypes.shape({
        items: PropTypes.arrayOf(PropTypes.shape()).isRequired,
        brochure: PropTypes.shape({
            file: PropTypes.shape(),
            type: PropTypes.string,
            translations: PropTypes.shape()
        }),
        translations: PropTypes.shape({
            shortText: PropTypes.string
        })
    }).isRequired
};

export default Pricing;



// WEBPACK FOOTER //
// ./src/components/content/estimation/pricing/Pricing.jsx